class skfHtml {
  attr: string;
  exp: any;
  $value: any;
  $index: number;

  constructor(private elem, private field: any) {
    this.attr = this.elem.getAttribute("skf-html");
    if (/\$value/.test(this.attr)) {
      const optionIndex = parseInt(this.elem.getAttribute("skf-options"), 10);
      this.$value = this.field.listOptions[optionIndex];
      this.$index = optionIndex;
    }
    if (/\$index/.test(this.attr)) {
      const optionIndex = parseInt(this.elem.getAttribute("skf-options"), 10);
      this.$index = optionIndex;
    }
    this.exp = new Function(
      "const $field = this.field; const $value = this.$value; const $index = this.$index; return " +
        this.attr
    );
  }

  update(): void {
    const value = this.exp.call(this);
    this.elem.innerHTML = value;
  }
}

export { skfHtml };
